import { uploadFilesGetLinks } from "../files";
import { API, authClient } from '../index';

// Get all actice deals
export const getAllActiveDeals = () => {
    return authClient().get(`${API}/deal/`)
}

// Get all deals
export const getAllDeals = () => {
    return authClient().get(`${API}/deal/?getDisabled=true`)
}

// Get deal by id
export const getDealById = (id) => {
    return authClient().get(`${API}/deal/${id}`)
}

// Create deal
export const postDeal = async (deal, documents, pathFolder) => {
    if (documents?.length > 0) {
        const response = await uploadFilesGetLinks(documents, pathFolder);
        deal.documents = response;
    }
    return authClient().post(`${API}/deal/`, deal)
}

// Update deal
export const updateDeal = async (id, deal, documents, pathFolder) => {
    if (documents?.length > 0) {
        const response = await uploadFilesGetLinks(documents, pathFolder);
        deal.documents = response;
    }

    return authClient().put(`${API}/deal/${id}`, deal)
}

// Change status deal
export const changeStatusDeal = async (id, active) => {
    return authClient().put(`${API}/deal/change-status/${id}`, { active });
};

/** Admin session only: move deal to NBO; NDA stays not signed. */
export const skipNdaToNbo = (id) => {
    return authClient().post(`${API}/deal/${id}/skip-nda-to-nbo`);
};


// Delete deal
export const deleteDeal = (id) => {
    return authClient().delete(`${API}/deal/${id}`)
}

export const getDocumentSigned = async (envelopeId) => {
    return authClient().get(`${API}/deal/sign/${envelopeId}`, { responseType: 'arraybuffer' });
};

